import Api from './api'
import Url from './request.url'

export default class ApplicationApi extends Api {

  constructor() {
    super()
  }

  putBoardReport(params) {
    return new Promise(resolve => {
      this.axios().put(Url.application.board.report, params).then(res => { resolve(res.data) })
    })
  }

  delFolder(params) {
    return new Promise(resolve => {
      this.axios().post(Url.application.board.delFolder, params).then(res => { resolve(res.data) })
    })
  }

  gDriveInput(params) {
    return new Promise(resolve => {
      this.axios().post(Url.application.board.gdrive, params).then(res => { resolve(res.data) })
    })
  }

  exportFile(params) {
    return new Promise(resolve => {
      this.axios().post(Url.application.board.export, params).then(res => { resolve(res.data) })
    })
  }

  getDataSource() {
    return new Promise(resolve => {
      this.axios().get(Url.application.board.datasource).then(res => { resolve(res.data) })
    })
  }

  
  checkFolder(params) {
    return new Promise(resolve => {
      this.axios().post(Url.application.board.getFolder, params).then(res => { resolve(res.data) })
    })
  }

  UpdateDataSource(params) {
    return new Promise(resolve => {
      this.axios().post(Url.application.board.uploadDS, params).then(res => { resolve(res) })
    })
  }

  originUpload(params) {
    return new Promise(resolve => {
      this.axios().post(Url.application.board.originUpload, params).then(res => { resolve(res.data) })
    })
  }

  devUpload(params) {
    return new Promise(resolve => {
      this.axios().post(Url.application.board.devUpload, params).then(res => { resolve(res.data) })
    })
  }

  tortueUpload(params) {
    return new Promise(resolve => {
      this.axios().post(Url.application.board.tortueUpload, params).then(res => { resolve(res.data) })
    })
  }

  getColumns(params) {
    return new Promise(resolve => {
      this.axios().post(Url.application.board.getColumns, params).then(res => { resolve(res.data) })
    })
  }

  updateColumns(params) {
    return new Promise(resolve => {
      this.axios().post(Url.application.board.updateColumns, params).then(res => { resolve(res.data) })
    })
  }

  editColumns(params) {
    return new Promise(resolve => {
      this.axios().post(Url.application.board.editColumns, params).then(res => { resolve(res.data) })
    })
  }

  delColumns(params) {
    return new Promise(resolve => {
      this.axios().post(Url.application.board.delColumns, params).then(res => { resolve(res.data) })
    })
  }
  
  getTables(params) {
    return new Promise(resolve => {
      this.axios().post(Url.application.board.getTables, params).then(res => { resolve(res.data) })
    })
  }
  
  updateTables(params) {
    return new Promise(resolve => {
      this.axios().post(Url.application.board.updateTables, params).then(res => { resolve(res.data) })
    })
  }

  editTables(params) {
    return new Promise(resolve => {
      this.axios().post(Url.application.board.editTables, params).then(res => { resolve(res.data) })
    })
  }

  delTables(params) {
    return new Promise(resolve => {
      this.axios().post(Url.application.board.delTables, params).then(res => { resolve(res.data) })
    })
  }  

  createSource(params) {
    return new Promise(resolve => {
      this.axios().post(Url.application.board.createSource, params).then(res => { resolve(res.data) })
    })
  } 
  
  setColumnScope(params) {
    return new Promise(resolve => {
      this.axios().post(Url.application.board.setColumnScope, params).then(res => { resolve(res.data) })
    })
  } 
}